import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  sectionContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    direction: "rtl",
  },
  cardRow: {
    display: "grid",
    gap: "10px",
    width: "100%",
    direction: "rtl",
  },
  cardRow2: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
  cardRow1: {
    gridTemplateColumns: "1fr",
  },
  cardRow3: {
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  },
  sectionTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
  },
  tablesWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "100%",
    direction: "rtl",
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: "16px",
  },
  tableBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    direction: "rtl",
  },
  tableHeaderRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    direction: "rtl",
    gap: "12px",
  },
  tableTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
  },
  addRowButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    height: 42,
    minHeight: 42,
    boxSizing: "border-box",
    padding: "10px 16px",
    borderRadius: "4px",
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "140%",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
    "& .MuiButton-startIcon": {
      margin: 0,
    },
    "& .MuiButton-endIcon": {
      margin: 0,
    },
  },
  table: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    border: `1px solid ${theme.palette.divider}`,
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
    overflow: "hidden",
    direction: "rtl",
  },
  tableHeadRow: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 1fr 88px 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.grey[400],
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
  },
  tableBodyRow: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 1fr 88px 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  tableHeadRowCompact: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.grey[400],
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
  },
  tableBodyRowCompact: {
    display: "grid",
    gridTemplateColumns: "48px 1fr 2fr",
    height: 52,
    minHeight: 52,
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    direction: "rtl",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  tableHeadCell: {
    padding: "0 12px",
    height: "100%",
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "21px",
    letterSpacing: 0,
    color: theme.palette.text.primary,
    textAlign: "right",
    direction: "rtl",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    minWidth: 0,
  },
  tableCell: {
    padding: "0 12px",
    minWidth: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    direction: "rtl",
  },
  tableIndexCell: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "21px",
    letterSpacing: 0,
    color: theme.palette.secondary.main,
    textAlign: "center",
    justifyContent: "center",
  },
  tableCellText: {
    width: "100%",
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    direction: "rtl",
    wordBreak: "break-word",
  },
  tyingStripModal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: 500,
    height: 310,
    boxSizing: "border-box",
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 4px 24px rgba(37, 56, 88, 0.12)",
    opacity: 1,
    outline: "none",
  },
  tyingStripModalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    width: "100%",
    height: 56,
    boxSizing: "border-box",
    gap: 10,
    padding: "16px 24px",
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    borderBottom: `1px solid ${theme.palette.divider}`,
    opacity: 1,
    backgroundColor: theme.palette.grey[400],
    direction: "rtl",
  },
  tyingStripModalTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    flex: 1,
    margin: 0,
  },
  tyingStripModalClose: {
    flexShrink: 0,
    padding: 0,
    width: 24,
    height: 24,
    color: theme.palette.text.primary,
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
  },
  tyingStripModalBody: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 16,
    flex: 1,
    minHeight: 0,
    padding: "16px 24px",
    backgroundColor: theme.palette.background.paper,
    direction: "rtl",
  },
  tyingStripModalField: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: "100%",
    opacity: 1,
  },
  tyingStripModalLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    margin: 0,
  },
  tyingStripModalInput: {
    width: "100%",
    margin: 0,
    opacity: 1,
    "& .MuiOutlinedInput-root": {
      height: 48,
      margin: 0,
      boxSizing: "border-box",
      borderRadius: "4px",
      backgroundColor: theme.palette.background.paper,
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
      color: theme.palette.secondary.main,
      opacity: 1,
      "& fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        borderWidth: "1px",
      },
    },
    "& .MuiOutlinedInput-input": {
      height: "100%",
      boxSizing: "border-box",
      padding: "12px 8px 12px 16px",
      textAlign: "right",
      direction: "rtl",
      "&::placeholder": {
        color: theme.palette.text.primary,
        opacity: 1,
      },
    },
  },
  tyingStripModalFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexShrink: 0,
    width: "100%",
    height: 56,
    boxSizing: "border-box",
    gap: 10,
    padding: "16px 24px",
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    opacity: 1,
    backgroundColor: theme.palette.grey[400],
    direction: "rtl",
  },
  tyingStripModalCancelBtn: {
    minWidth: 88,
    height: 32,
    padding: "6px 16px",
    borderRadius: "4px",
    borderColor: theme.palette.divider,
    color: theme.palette.secondary.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "21px",
    textTransform: "none",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "none",
    "&:hover": {
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.background.paper,
      boxShadow: "none",
    },
  },
  tyingStripModalAddBtn: {
    minWidth: 88,
    height: 32,
    padding: "6px 16px",
    borderRadius: "4px",
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "21px",
    textTransform: "none",
    backgroundColor: theme.palette.primary.main,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
    },
  },
}));
